module.exports = __webpack_public_path__ + "img/logo_liputan6.2f17dc59.png";